import React from 'react';
import { Pressable } from 'react-native';
import PropTypes from 'prop-types';
import { H6 } from '../text';

export const ViewMore = ({ color, handler = () => {}, text = 'more' }) => {
    return (
        <Pressable onPress={handler} style={{ alignItems: 'center' }}>
            <H6 style={{ color: color || '#a61a2b' }} text={text.equals('more') ? '+' : '-'} />
            <H6 onPress={handler} style={{ color: color || '#a61a2b' }} text={`View ${text.initCaps()}`} />
        </Pressable>
    );
};

ViewMore.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
    handler: PropTypes.func
};
